import React, { useEffect, useState } from 'react';
import api from '../services/api'
import { paramsToObject, formToObject } from '../utils/functions'
import { MDBContainer, MDBIframe, MDBModalBody } from "mdbreact";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import { Icon } from 'react-icons-kit'
import { ic_search } from 'react-icons-kit/md/ic_search'
import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Bloquetos() {
    const [data, setData] = useState([])
    const [auth, setAuth] = useState(JSON.parse(localStorage['authKSA'] || JSON.stringify({ authenticated: false, user: 0 })));

    useEffect(() => {
        const fetchData = async () => {
            swal.fire({
                html: <FrLoading text="Carregando..." />,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            })

            const urlParams = new URLSearchParams(window.location.search);
            let query = paramsToObject(urlParams)

            await api.get('/financeiro?pks=' + query.pks + '&uex=' + auth.user).then(r => {
                console.log(r.data)
                setData(r.data)
            })

            swal.close()

        }

        fetchData()
    }, [])

    return (
        <div className="Manut">
            {/* <NavBar /> */}
            <div className="ManutContent">
                <div className="defaultHeader">
                    <h1>Bloquetos</h1>
                    <UserOptions />
                </div>
                <br />
                <form id="searchForm">
                    {/* <div> */}
                    {/* <div> */}
                    {/* <MDBContainer className="text-center"> */}



                    {data.map((d) => (
                        <MDBIframe src={d.LINK_BLOQUETO} />

                    ))
                    }

                </form>
                <FooterDelphus />
            </div >
        </div >
    );
}

export default Bloquetos;
